import {useMutation} from '@apollo/react-hooks';

import type {
    AddModalFieldsUpdate as AddModalFieldsUpdateMutation,
    AddModalFieldsUpdateVariables as AddModalFieldsUpdateMutationVariables,
    AddModalFieldsUpdateInput,
} from 'nutshell-graphql-types';

import ADD_MODAL_FIELDS_UPDATE from './graphql/mutations/add-modal-fields-update.graphql';
import GET_FIELDS from './graphql/queries/get-fields.graphql';

export function useUpdateFields(): (arg1: AddModalFieldsUpdateInput) => Promise<any> {
    const [saveFields] = useMutation<
        AddModalFieldsUpdateMutation,
        AddModalFieldsUpdateMutationVariables
    >(ADD_MODAL_FIELDS_UPDATE);

    return (input: AddModalFieldsUpdateInput) => {
        return saveFields({
            variables: {input},
            update: (proxy, mutationResults) => {
                // Read the data from our cache for this query.
                const cacheResult = proxy.readQuery({
                    query: GET_FIELDS,
                    variables: {entityType: input.entityType},
                });

                if (cacheResult) {
                    const updatedFields =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.addModalFieldsUpdate;

                    if (!updatedFields) return;

                    proxy.writeQuery({
                        query: GET_FIELDS,
                        variables: {entityType: input.entityType},
                        data: {
                            createModalFields: updatedFields,
                        },
                    });
                }
            },
        });
    };
}
